(() => {
  const slides = [
    {
      left: 'https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=900&auto=format&fit=crop',
      right: 'https://images.unsplash.com/photo-1519340241574-2cec6aef0c01?w=900&auto=format&fit=crop',
      image: 'https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=400&auto=format&fit=crop',
      title: 'Charming<br>Cuddlewear',
    },
    {
      left: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=900&auto=format&fit=crop',
      right: 'https://images.unsplash.com/photo-1519238359922-989348752efb?w=900&auto=format&fit=crop',
      image: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400&auto=format&fit=crop',
      title: 'Delightful<br>Accessories',
    },
    {
      left: 'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=900&auto=format&fit=crop',
      right: 'https://images.unsplash.com/photo-1514090458221-65bb69cf63e6?w=900&auto=format&fit=crop',
      image: 'https://images.unsplash.com/photo-1514090458221-65bb69cf63e6?w=400&auto=format&fit=crop',
      title: 'Playful<br>Essentials',
    },
    {
      left: 'https://images.unsplash.com/photo-1519238359922-989348752efb?w=900&auto=format&fit=crop',
      right: 'https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=900&auto=format&fit=crop',
      image: 'https://images.unsplash.com/photo-1519238359922-989348752efb?w=400&auto=format&fit=crop',
      title: 'Little<br>Fashion',
    },
    {
      left: 'https://images.unsplash.com/photo-1519340241574-2cec6aef0c01?w=900&auto=format&fit=crop',
      right: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=900&auto=format&fit=crop',
      image: 'https://images.unsplash.com/photo-1519340241574-2cec6aef0c01?w=400&auto=format&fit=crop',
      title: 'Kids<br>Adventure',
    },
    {
      left: 'https://images.unsplash.com/photo-1514090458221-65bb69cf63e6?w=900&auto=format&fit=crop',
      right: 'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=900&auto=format&fit=crop',
      image: 'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=400&auto=format&fit=crop',
      title: 'Fantastic<br>Fashion',
    },
  ];

  const initialize = (section) => {
    if (section.dataset.mobileCardsReady === 'true') return;

    const first = section.querySelector('#inletixCardOne');
    const second = section.querySelector('#inletixCardTwo');
    const lowerArrows = section.querySelector('.inletix-mid-arrows:last-child');
    const leftStack = section.querySelector('#inletixLeftStack');
    const rightStack = section.querySelector('#inletixRightStack');
    if (!first || !second || !lowerArrows) return;

    const third = second.cloneNode(true);
    third.id = 'inletixCardThree';
    third.classList.remove('active');
    lowerArrows.before(third);
    section.dataset.mobileCardsReady = 'true';

    let wheelIndex = 0;

    const getSlideIndexFromCard = (card) => {
      const currentTitle = card.querySelector('h3')?.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      return slides.findIndex((slide) =>
        slide.title.replace('<br>', ' ').toLowerCase().includes(currentTitle)
      );
    };

    const setCard = (card, item) => {
      const image = card.querySelector('img');
      const title = card.querySelector('h3');
      if (image) image.src = item.image;
      if (title) title.innerHTML = item.title;
    };

    const setActiveCard = () => {
      first.classList.remove('active');
      second.classList.add('active');
      third.classList.remove('active');
    };

    const renderSideStack = (stack, sideKey, activeIndex) => {
      if (!stack) return;

      stack.innerHTML = '';

      for (let i = 0; i < 3; i += 1) {
        const item = slides[(activeIndex + i) % slides.length];
        const image = item[sideKey] || item.image;
        const card = document.createElement('div');
        card.className = 'inletix-slide-img';
        card.innerHTML = `<img src="${image}" alt="">`;
        stack.appendChild(card);
      }
    };

    const syncSideStacks = () => {
      const activeIndex = (wheelIndex + 1) % slides.length;
      renderSideStack(leftStack, 'left', activeIndex);
      renderSideStack(rightStack, 'right', activeIndex);
    };

    const syncVisibleCards = () => {
      setCard(first, slides[wheelIndex % slides.length]);
      setCard(second, slides[(wheelIndex + 1) % slides.length]);
      setCard(third, slides[(wheelIndex + 2) % slides.length]);
      setActiveCard();
      syncSideStacks();
    };

    const moveWheel = (direction) => {
      if (direction === 'next') {
        wheelIndex = (wheelIndex + 1) % slides.length;
      } else {
        wheelIndex = (wheelIndex - 1 + slides.length) % slides.length;
      }

      syncVisibleCards();
    };

    const initialIndex = getSlideIndexFromCard(first);
    wheelIndex = initialIndex < 0 ? 0 : initialIndex;

    section.querySelectorAll('.inletix-mid-arrow-up').forEach((button) => {
      button.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          moveWheel('prev');
        },
        true
      );
    });

    section.querySelectorAll('.inletix-mid-arrow-down, .inletix-mid-card button').forEach((button) => {
      button.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          moveWheel('next');
        },
        true
      );
    });

    syncVisibleCards();
  };

  const initializeAll = () => {
    document.querySelectorAll('.inletix-kids-collection').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
